module.exports = __webpack_public_path__ + "media/assets/faria_products/Curriculum First-dd972552389c679c9f4010841bea7c4fbcea6fd64764640bf51abafaa82d0dd4.png";